import { takeLatest, put, call, select, all } from 'redux-saga/effects';
import SearchApi from '../sdk/search/Api';
import { FETCH_FEATURED_AD_REQUEST } from './constants';
import * as actions from './actions';
import { infrastructureIdSelector } from '../Notifications/selectors';
import normalizeAd from '../normalize/ad';
import SectionIds from '../tracking/SectionIds';
import clientConfig from '../../parameters/client/config';
import SectionTypes from '../tracking/SectionTypes';
import { getAlreadyShownOnce } from './selectors';
import { countryAndVerticalSelector } from '~/common/selectors/config';
import { trovitSelector } from '~/common/selectors/trovit';

const searchApi = new SearchApi(clientConfig.searchApi);

export function* fetchFeaturedAdRequest({ payload }) {
  try {
    const alreadyShownOnce = yield select(getAlreadyShownOnce);
    if (alreadyShownOnce) {
      return;
    }

    yield put(actions.fetchFeaturedAdStart());

    const { verticalName, countryCode } = yield select(countryAndVerticalSelector);
    const trovit = yield select(trovitSelector);
    const userId = yield select(infrastructureIdSelector);

    const response = yield call([searchApi, searchApi.ad], {
      id: payload.featuredAdId,
      verticalName,
      countryCode,
      trovit,
      userId,
    });
    let featuredAd = normalizeAd(response, verticalName);

    // decorate ads with Section properties
    featuredAd = {
      ...featuredAd,
      ...{
        section_id: SectionIds.SECTION_RETENTION_FEATURED,
        section_type_id: SectionTypes.SECTION_TYPE_ORGANIC,
        redirectUrl: featuredAd.redirectUrl
          // Replace section Id from Source to FeaturedAd
          .replace(
            `section.${SectionIds.SECTION_ADPAGE_VISIT_SOURCE}`,
            `section.${SectionIds.SECTION_RETENTION_FEATURED}`
          )
          // Remove force no adpage
          .replace('fna.1/', ''),
      },
    };

    yield put(actions.fetchFeaturedAdSuccess(featuredAd));
  } catch (error) {
    yield put(actions.fetchFeaturedAdFailed(error));
  }
}

export default function* suggestionsSagas() {
  yield all([takeLatest(FETCH_FEATURED_AD_REQUEST, fetchFeaturedAdRequest)]);
}



// WEBPACK FOOTER //
// ./app/FeaturedAd/sagas.js